(function () {
  function setupCard(card) {
    if (card.dataset.hoverPlayInit) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return;
    }
    var media = card.querySelector('video-media');
    if (!media) return;

    card.dataset.hoverPlayInit = '1';

    function loadAndGetVideo() {
      var tpl = media.querySelector('template');
      if (tpl) {
        var clone = tpl.content.firstElementChild.cloneNode(true);
        tpl.replaceWith(clone);
        media.setAttribute('loaded', '');

        var vid = media.querySelector('video');
        if (vid) {
          vid.addEventListener('play', function () {
            media.setAttribute('playing', '');
          });
          vid.addEventListener('pause', function () {
            if (!vid.seeking && vid.paused) {
              media.removeAttribute('playing');
            }
          });
        }
      }
      return media.querySelector('video');
    }

    card.addEventListener('mouseenter', function () {
      if (media.hasAttribute('autoplay')) {
        return;
      }
      var video = loadAndGetVideo();
      if (!video) return;
      video.muted = true;
      video.play().catch(function () {});
    });

    card.addEventListener('mouseleave', function () {
      if (media.hasAttribute('autoplay')) return;
      var video = media.querySelector('video');
      if (!video || video.paused) return;
      video.pause();
    });
  }

  function initAll() {
    document.querySelectorAll('.shop-the-feed .media-card').forEach(setupCard);
  }

  if (window.customElements) {
    customElements.whenDefined('video-media').then(initAll);
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
})();
